import { Context } from "react";
import { KeycloakContext, KeycloakState } from "./keycloak-auth";
import { LegacyAuthContext, LegacyAuthState } from "./legacy-auth";

export type AuthState = LegacyAuthState | KeycloakState;

export const AuthContext = (
  process.env.REACT_APP_AUTH_METHOD === "KEYCLOAK"
    ? KeycloakContext
    : LegacyAuthContext
) as Context<AuthState>;

export default AuthContext;
